import { render, staticRenderFns } from "./audio.vue?vue&type=template&id=85ef3b2a&scoped=true"
import script from "./audio.vue?vue&type=script&lang=js"
export * from "./audio.vue?vue&type=script&lang=js"
import style0 from "./audio.vue?vue&type=style&index=0&id=85ef3b2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ef3b2a",
  null
  
)

export default component.exports